
import PriceCurrent from './PriceCurrent.vue'
import PriceOriginal from './PriceOriginal.vue'

export default {
  components: {
    PriceCurrent,
    PriceOriginal,
  },
  props: {
    /**
     * Backmarket's price
     *
     * @typedef {object} originalPrice
     * @property {number} price.raw
     * @property {string} price.display
     */
    price: {
      type: Object,
      default: () => ({}),
    },
    /**
     * Before Backmarket's price
     *
     * @typedef {object} originalPrice
     * @property {number} originalPrice.raw
     * @property {string} originalPrice.display
     */
    originalPrice: {
      type: Object,
      default: () => ({}),
    },
    size: {
      type: String,
      default: 'small',
      validator: (value) => ['small', 'medium', 'large'].includes(value),
    },
  },
  computed: {
    isDisplayedOriginalPrice() {
      const originalPriceValue = parseFloat(this.originalPrice.raw)
      const priceValue = parseFloat(this.price.raw)

      return (
        !Number.isNaN(originalPriceValue) && priceValue < originalPriceValue
      )
    },
  },
}
